import React, { useState } from "react";
import Button from "../button";
import BaseModal from "../modal/base/BaseModal";

type DialogProps = {
  close: () => void;
  defaultValue?: string;
  maxLength?: number;
  onConfirm?: (email: string) => void;
};

const EmailDialog = (props: DialogProps) => {
  const { close, defaultValue = "", maxLength = 100, onConfirm } = props;
  const [email, setEmail] = useState(defaultValue);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setEmail(e.target.value.slice(0, maxLength));
  };

  const handleConfirm = () => {
    // 모달 닫기는 호출부(성공 alert 확인)에서 처리
    onConfirm?.(email.trim());
  };

  return (
    <BaseModal className="p-[20px] rounded-none" size="dialog" close={close}>
      <section className="flex flex-col min-h-[154px] justify-between">
        <p className="text-base font-semibold text-center mb-[20px]">
          이메일 수정
        </p>

        {/* 이메일 입력 */}
        <div className="space-y-[4px] mb-[30px]">
          <p className="text-right text-xs">
            <span>{email.length}</span>
            <span className="text-[#888]">/{maxLength}</span>
          </p>
          <input
            value={email}
            onChange={handleChange}
            maxLength={maxLength}
            placeholder="예) user@email.com"
            className="w-full min-h-[40px] rounded-[8px] border border-[#d9d9d9] px-[16px] font-normal text-base outline-none focus:ring-1 focus:ring-black py-[12px]"
          />
        </div>

        <div className="flex justify-center gap-x-[8px] mx-auto">
          <Button
            className="text-base font-normal px-[22.5px] py-[12px]"
            label="취소"
            variant={"white"}
            onClick={close}
          />
          <Button
            className="text-base font-normal px-[22.5px] py-[12px]"
            label="변경"
            variant={"black"}
            onClick={handleConfirm}
          />
        </div>
      </section>
    </BaseModal>
  );
};

export default React.memo(EmailDialog);
